import { store } from './store.js';

let problemHelpData = null;

export async function loadProblemHelpData() {
    if (problemHelpData) return problemHelpData;
    try {
        const response = await fetch('problemHelpData.json');
        if (response.ok) {
            problemHelpData = await response.json();
            return problemHelpData;
        }
    } catch (e) {
        console.warn('⚠️ Standard fetch for problemHelpData.json failed:', e);
    }

    try {
        const response = await fetch('./problemHelpData.json');
        if (response.ok) {
            problemHelpData = await response.json();
            return problemHelpData;
        }
    } catch (e) {
        console.error('❌ Failed to load problemHelpData.json:', e);
    }
    return problemHelpData;
}
window.loadProblemHelpData = loadProblemHelpData;

/**
 * Check if an emoji code is valid
 */
function isValidEmojiCode(emojiCode) {
    return emojiCode && typeof emojiCode === 'string' && emojiCode.length > 0;
}

/**
 * Get best emoji code from text or default
 */
function getBestEmoji(text, defaultEmoji = '') {
    const lower = (text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    
    // Diccionario extendido de términos a código Twemoji (hexadecimal)
    const emojiMap = {
        // Alimentos y bebidas
        'sandwich': '1f96a', 'sandwiches': '1f96a',
        'hamburguesa': '1f354', 'hamburguesas': '1f354',
        'pizza': '1f355', 'pizzas': '1f355',
        'palomita': '1f37f', 'palomitas': '1f37f',
        'refresco': '1f964', 'refrescos': '1f964', 'bebida': '1f964', 'bebidas': '1f964',
        'manzana': '1f34e', 'manzanas': '1f34e',
        'pera': '1f350', 'peras': '1f350',
        'platano': '1f34c', 'platanos': '1f34c',
        'naranja': '1f34a', 'naranjas': '1f34a',
        'fresa': '1f353', 'fresas': '1f353',
        'uva': '1f347', 'uvas': '1f347',
        'sandia': '1f349', 'sandias': '1f349',
        'melon': '1f348', 'melones': '1f348',
        'pina': '1f34d', 'pinas': '1f34d',
        'limon': '1f34b', 'limones': '1f34b',
        'cereza': '1f352', 'cerezas': '1f352',
        'melocoton': '1f351', 'melocotones': '1f351',
        'ciruela': '1f96d', 'ciruelas': '1f96d',
        'tomate': '1f345', 'tomates': '1f345',
        'zanahoria': '1f955', 'zanahorias': '1f955',
        'lechuga': '1f96c', 'lechugas': '1f96c',
        'patata': '1f954', 'patatas': '1f954',
        'huevo': '1f95a', 'huevos': '1f95a',
        'leche': '1f95b',
        'galleta': '1f36a', 'galletas': '1f36a',
        'caramelo': '1f36c', 'caramelos': '1f36c', 'chuche': '1f36c', 'chuches': '1f36c',
        'piruleta': '1f36d', 'piruletas': '1f36d',
        'helado': '1f366', 'helados': '1f366',
        'tarta': '1f382', 'tartas': '1f382', 'pastel': '1f382', 'pasteles': '1f382',
        'chocolatina': '1f36b', 'chocolatinas': '1f36b', 'chocolate': '1f36b', 'chocolates': '1f36b',
        'pan': '1f35e', 'panes': '1f35e',
        'queso': '1f9c0', 'quesos': '1f9c0',

        // Objetos, fiesta y parque
        'globo': '1f388', 'globos': '1f388',
        'regalo': '1f381', 'regalos': '1f381',
        'vela': '1f56f', 'velas': '1f56f',
        'ticket': '1f39f', 'tickets': '1f39f', 'entrada': '1f39f', 'entradas': '1f39f',
        'premio': '1f3c6', 'premios': '1f3c6', 'trofeo': '1f3c6', 'trofeos': '1f3c6',
        'pelota': '26bd', 'pelotas': '26bd', 'balon': '26bd', 'balones': '26bd',
        'coche': '1f697', 'coches': '1f697', 'auto': '1f697', 'autos': '1f697',
        'bici': '1f6b2', 'bicis': '1f6b2', 'bicicleta': '1f6b2', 'bicicletas': '1f6b2',
        'muneca': '1f9f8', 'munecas': '1f9f8', 'peluche': '1f9f8', 'peluches': '1f9f8',
        'tren': '1f682', 'trenes': '1f682',
        'avion': '2708', 'aviones': '2708',
        'barco': '1f6a2', 'barcos': '1f6a2',
        'caja': '1f4e6', 'cajas': '1f4e6',

        // Colegio y estudio
        'libro': '1f4d6', 'libros': '1f4d6',
        'lapiz': '270f', 'lapices': '270f',
        'cuaderno': '1f4d3', 'cuadernos': '1f4d3',
        'mochila': '1f392', 'mochilas': '1f392',
        'tijera': '2702', 'tijeras': '2702',
        'regla': '1f4d8', 'reglas': '1f4d8',

        // Naturaleza y animales
        'pajaro': '1f426', 'pajaros': '1f426',
        'perro': '1f436', 'perros': '1f436',
        'gato': '1f431', 'gatos': '1f431',
        'pez': '1f41f', 'peces': '1f41f',
        'tortuga': '1f422', 'tortugas': '1f422',
        'flor': '1f338', 'flores': '1f338',
        'arbol': '1f333', 'arboles': '1f333',
        'hoja': '1f343', 'hojas': '1f343',
        'estrella': '2b50', 'estrellas': '2b50',

        // Personas
        'nino': '1f466', 'ninos': '1f466',
        'nina': '1f467', 'ninas': '1f467',
        'amigo': '1f9d1', 'amigos': '1f9d1',
        'persona': '1f465', 'personas': '1f465', 'invitado': '1f465', 'invitados': '1f465',
        'moneda': '1f4b0', 'monedas': '1f4b0', 'billete': '1f4b5', 'billetes': '1f4b5'
    };

    // 1. Prioridad: Buscar coincidencia en el texto del enunciado
    if (lower) {
        for (const [key, value] of Object.entries(emojiMap)) {
            if (lower.includes(key)) {
                return value;
            }
        }
    }

    // 2. Si hay un defaultEmoji válido y no es el globo asignado por defecto ("1f388")
    // (a menos que el texto contenga la palabra "globo")
    if (defaultEmoji && isValidEmojiCode(defaultEmoji) && defaultEmoji !== '2753') {
        if (defaultEmoji !== '1f388' || (lower && lower.includes('globo'))) {
            return defaultEmoji;
        }
    }

    // 3. Fallback: Usar marcador de cuadradito azul (.unit-square)
    return 'UNIT_SQUARE';
}
window.getBestEmoji = getBestEmoji;

const TWEMOJI_CDN = 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14/assets/svg/';

/**
 * Generate Twemoji image HTML with Ten Grouping
 */
function generateTwemojiImages(emojiCode, count) {
    if (count <= 0) return '';

    const tens = Math.floor(count / 10);
    const units = count % 10;

    // Si el emoji es 'UNIT_SQUARE', '2753' (interrogación), o no es un emoji válido
    const isPlaceholder = !isValidEmojiCode(emojiCode) || emojiCode === '2753' || emojiCode === 'UNIT_SQUARE';

    const maxTotalItems = 30; // Un poco más generoso

    let html = '';

    // 1. Generar Cajas de Decenas
    for (let i = 0; i < tens; i++) {
        html += `<div class="ten-group-box">10</div>`;
    }

    // 2. Generar Unidades Sueltas
    const renderUnit = () => {
        if (isPlaceholder) {
            return `<div class="unit-square"></div>`;
        } else {
            return `<img class="twemoji" src="${TWEMOJI_CDN}${emojiCode}.svg" alt="" onerror="this.outerHTML='<div class=\\'unit-square\\'></div>'">`;
        }
    };

    if (tens > 0) {
        for (let i = 0; i < units; i++) {
            html += renderUnit();
        }
    } else {
        const displayCount = Math.min(count, maxTotalItems);
        for (let i = 0; i < displayCount; i++) {
            html += renderUnit();
        }
        if (count > maxTotalItems) {
            html += `<span class="more-indicator">+${count - maxTotalItems}</span>`;
        }
    }

    return html;
}

function findCurrentProblemHelpData() {
    if (!problemHelpData) return null;

    const currentContext = typeof store !== 'undefined' ? store.config.context : null;
    const currentProblemIndex = typeof store !== 'undefined' ? store.state.currentProblem : 0;
    const currentProblem = typeof store.state !== 'undefined' && store.state.problems
        ? store.state.problems[currentProblemIndex]
        : null;

    if (!currentProblem) return null;

    let sheetName = null;
    if (typeof ExcelLoader !== 'undefined' && ExcelLoader.CONFIG && ExcelLoader.CONFIG.CONTEXT_TO_SHEET) {
        sheetName = ExcelLoader.CONFIG.CONTEXT_TO_SHEET[currentContext];
    }
    if (!sheetName) sheetName = currentContext?.toUpperCase() || '';

    let contextData = problemHelpData[sheetName];

    // Búsqueda Robusta: Si no hay match exacto, buscar normalizando (fruteria vs FRUTERÍA)
    if (!contextData) {
        const normalizeKey = (s) => (s || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const normSheet = normalizeKey(sheetName);
        const bestKey = Object.keys(problemHelpData).find(k => normalizeKey(k) === normSheet);
        if (bestKey) {
            contextData = problemHelpData[bestKey];
        }
    }

    if (!contextData) return null;

    const problemId = currentProblem.id || (currentProblemIndex + 1);
    let helpEntry = contextData.find(p => p.id === problemId);

    if (!helpEntry && currentProblem.statement) {
        const currentStatement = typeof currentProblem.statement === 'string'
            ? currentProblem.statement
            : currentProblem?.statement?.['es-ES'] || Object.values(currentProblem.statement)[0];

        helpEntry = contextData.find(p => {
            const entryStart = p.enunciado?.substring(0, 50).toLowerCase() || '';
            const currentStart = currentStatement?.substring(0, 50).toLowerCase() || '';
            return entryStart === currentStart || currentStatement?.includes(p.enunciado?.substring(0, 30));
        });
    }

    return helpEntry;
}

/**
 * Create fallback help data
 */
function createFallbackHelpData(problem) {
    let statement = '';
    if (typeof problem.statement === 'string') {
        statement = problem.statement;
    } else if (problem.statement) {
        statement = problem?.statement?.['es-ES'] || Object.values(problem.statement)[0] || '';
    }

    const questionMatch = statement.match(/[¿]([^?]+)[?]/);
    const question = questionMatch ? questionMatch[0] : '';

    // Mejorar extracción de datos numéricos
    const usefulData = problem.data && problem.data.useful ? problem.data.useful : [];
    const data1 = usefulData[0] !== undefined ? usefulData[0] : (problem.data1 || problem.num1 || 0);
    const data2 = usefulData[1] !== undefined ? usefulData[1] : (problem.data2 || problem.num2 || 0);

    // USAR NUEVO PARSER SI EXISTE
    let startText = '';
    let changeText = '';

    if (window.parseProblemStatement) {
        // Usar parser inteligente
        const parsed = window.parseProblemStatement(statement, data1, data2);
        startText = parsed.start;
        changeText = parsed.change;
        // parsed.question ya lo tenemos o podemos usarlo, pero mantengo lógica abajo para compatibilidad
    } else {
        // Fallback antiguo
        const textWithoutQuestion = statement.replace(/[¿][^?]+[?]/, '').trim();
        const parts = textWithoutQuestion.split(/\s+(?:y|pero|,\s*pero)\s+/);
        startText = parts[0] || '';
        changeText = parts[1] || '';
    }

    const textWithoutQuestion = statement.replace(/[¿][^?]+[?]/, '').trim();
    // const parts = textWithoutQuestion.split(/\s+(?:y|pero|,\s*pero)\s+/); // REMOVED

    const selectedEmoji = getBestEmoji(statement);

    return {
        ayuda: {
            inicio: { texto: startText, cantidad: data1, emoji: selectedEmoji, objeto: '' },
            cambio: {
                texto: changeText,
                cantidad: data2,
                emoji: selectedEmoji,
                objeto: '',
                operacion: problem.operation === 'resta' || problem.operation === '-' ? '-' : '+'
            },
            pregunta: { texto: question }
        }
    };
}

function ensureModalExists(forceRebuild = false) {
    // 1. Inject Styles Definitively
    if (!document.getElementById('problem-help-modal-styles-v2')) {
        const style = document.createElement('style');
        style.id = 'problem-help-modal-styles-v2';
        style.textContent = `
            #problemHelpModalV2 {
                position: fixed !important;
                top: 0 !important;
                left: 0 !important;
                width: 100vw !important;
                height: 100vh !important;
                background-color: rgba(0, 0, 0, 0.85) !important;
                z-index: 2147483647 !important; /* Max z-index */
                display: flex !important;
                justify-content: center !important;
                align-items: center !important;
                padding: 1rem !important;
                box-sizing: border-box !important;
                backdrop-filter: blur(4px);
            }
            #problemHelpModalV2.hidden {
                display: none !important;
            }
            .problem-help-content {
                position: relative !important;
                background: #ffffff !important;
                width: 100% !important;
                max-width: 850px !important;
                max-height: 90vh !important;
                overflow-y: auto !important;
                border-radius: 16px !important;
                box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6) !important;
                display: flex !important;
                flex-direction: column !important;
                margin: auto !important; /* Center safe */
                border: 4px solid #cbd5e1 !important;
            }
            @media (max-width: 480px) {
                #problemHelpModalV2 {
                    padding: 0.5rem !important;
                }
                .problem-help-content {
                    max-height: 95vh !important;
                    border-width: 2px !important;
                }
                .help-content-body {
                    padding: 0.5rem !important;
                }
                .help-modal-footer {
                    padding-top: 0.2rem !important;
                }
            }
            .help-content-body {
                padding: 1rem;
                overflow: visible !important;
                position: relative;
                z-index: 100;
            }
            .ten-group-box {
                /* Caja 3D */
                display: flex;
                align-items: center;
                justify-content: center;
                width: 36px;
                height: 36px;
                background: linear-gradient(135deg, #fca5a5 0%, #f87171 100%);
                border: 1px solid #dc2626;
                border-bottom-width: 4px;
                border-right-width: 3px;
                border-radius: 6px;
                color: #7f1d1d;
                font-weight: 800;
                font-size: 1.1rem;
                margin-right: 6px;
                text-shadow: 0 1px 0 rgba(255,255,255,0.4);
                transform: translateY(-2px);
                box-shadow: 0 4px 6px rgba(0,0,0,0.15);
            }
            .help-image-container {
                text-align: center;
                margin-bottom: 1rem;
                padding: 10px;
                background-color: #f1f5f9;
                border: 2px dashed #cbd5e1;
                border-radius: 12px;
                overflow: visible !important; /* Allow zoom overflow */
                position: relative;
                z-index: 10;
            }
            #helpImage {
                max-height: 220px;
                width: auto;
                max-width: 100%;
                border-radius: 8px;
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1); /* Springy zoom */
                cursor: zoom-in;
                transform-origin: center center;
            }
            #helpImage:hover {
                transform: scale(1.03);
                z-index: 50;
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2);
                position: relative;
                cursor: pointer;
            }
            .unit-square {
                display: inline-block;
                width: 22px;
                height: 22px;
                background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%); /* Blue always for units */
                border: 1px solid #2563eb;
                border-bottom-width: 3px;
                border-right-width: 2px;
                border-radius: 4px;
                margin-right: 4px;
                vertical-align: middle;
                box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
        `;
        document.head.appendChild(style);
    }

    // Clean up OLD version if exists
    const oldModal = document.getElementById('problemHelpModal');
    if (oldModal) oldModal.remove();

    const existingModal = document.getElementById('problemHelpModalV2');
    if (existingModal) {
        if (forceRebuild) {
            existingModal.remove();
        } else {
            return;
        }
    }

    // Default structure for Step 1
    const modalHTML = `
    <div id="problemHelpModalV2" class="hidden">
        <div class="problem-help-content">
            <h2 class="problem-help-title">💡 UN POCO DE AYUDA</h2>
            <div class="help-content-body">
                <div id="helpImageContainer" class="help-image-container" style="display:none;">
                    <img id="helpImage" src="" alt="Ayuda visual" onerror="this.parentElement.style.display='none'" onclick="if(window.expandInfographic) window.expandInfographic(this.src)" />
                </div>
                <div class="help-decomposition">
                    <div class="problem-help-section">
                        <div class="section-part">
                            <span class="section-label">AL PRINCIPIO...</span>
                            <button class="btn-audio-inline help-audio-btn" id="audioBtnInicio"><span>🔊</span></button>
                            <span id="helpInicioText" class="section-text"></span>
                        </div>
                        <div id="helpInicioEmojis" class="visual-emojis"></div>
                    </div>
                    <div class="problem-help-section">
                        <div class="section-part">
                            <span class="section-label cambio">DESPUÉS...</span>
                            <button class="btn-audio-inline help-audio-btn" id="audioBtnCambio"><span>🔊</span></button>
                            <span id="helpCambioOperator" class="cambio-operator"></span>
                            <span id="helpCambioText" class="section-text"></span>
                        </div>
                        <div id="helpCambioImages" class="visual-emojis"></div>
                        <div id="helpCambioEmojis" style="display:none"></div>
                    </div>
                    <div class="problem-help-section">
                        <div class="section-part">
                            <span class="section-label pregunta">PREGUNTA</span>
                            <button class="btn-audio-inline help-audio-btn" id="audioBtnPregunta"><span>🔊</span></button>
                            <span id="helpPreguntaText" class="section-text question-text"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="help-modal-footer" style="display: flex; flex-wrap: wrap; justify-content: center; gap: 10px;">
                <button class="btn-audio-narrative" id="btnPlayAllHelp" style="flex: 1 1 140px; margin: 0; min-width: 140px;">
                    <span>🔊</span> ESCUCHAR TODO
                </button>
                <button class="btn-close-modal" onclick="closeProblemHelpModal()" style="flex: 1 1 140px; margin: 0; min-width: 140px;">✅ ¡ENTENDIDO!</button>
            </div>
        </div>
    </div>`;

    const div = document.createElement('div');
    div.innerHTML = modalHTML;
    document.body.appendChild(div.firstElementChild);
}

/**
 * Render specific content for Step 2 (Data Highlighting)
 */
function renderStep2HelpContent(modal) {
    const contentContainer = modal.querySelector('.problem-help-content');
    if (!contentContainer) return;

    // Textos para leer
    const textPart1 = "Cuando se habla de datos, ¡los números nunca van solos! El 5 es solo un número 5, el dato sería 5 helados de chocolate. Explicación: Si solo dices 5, no sabemos si hablas de elefantes o de caramelos. La regla de oro: Los datos son el número más el objeto.";
    const textPart2 = "Detective de Datos Útiles. En un problema puede haber muchos números, pero solo son datos útiles los que nos ayudan a resolver la pregunta.";

    contentContainer.innerHTML = `
        <h2 class="problem-help-title" style="color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 10px;">💡 AYUDA: DETECTIVE DE DATOS</h2>
        <div class="help-content-body" style="text-align: left; font-size: 1rem; color: #333; overflow-y: auto; max-height: 60vh; padding: 10px;">
            
            <div style="position: relative;">
                <button class="btn-audio-inline" onclick="toggleAudio(this, '${textPart1}')" style="float: right; margin-left:10px;" aria-label="Escuchar explicación"><span>🔊</span></button>
                <p style="margin-bottom: 1rem; font-size: 1.1rem;">Cuando se habla de datos, <strong style="color: #e67e22;">¡los números nunca van solos!</strong></p>
                <p style="margin-bottom: 1rem;">El <strong>5</strong> es solo un número 5, el dato sería <strong>"5 helados de chocolate"</strong>.</p>
                
                <ul style="margin-bottom: 1.5rem; padding-left: 1rem; list-style: none;">
                    <li style="margin-bottom: 0.8rem;">🔹 <strong>Explicación:</strong> Si solo dices "5", no sabemos si hablas de elefantes o de caramelos.</li>
                    <li>🔹 <strong>La regla de oro:</strong> Los datos son el número + el objeto.
                        <ul style="list-style-type: none; margin-top: 0.5rem; padding-left: 1rem; background: #fff5f5; padding: 10px; border-radius: 8px;">
                            <li style="margin-bottom: 0.25rem; color: #c0392b;">❌ Mal: "Tengo 3".</li>
                            <li style="color: #27ae60;">✅ Bien: "Tengo 3 manzanas".</li>
                        </ul>
                    </li>
                </ul>
            </div>

            <div style="position: relative; margin-top: 1.5rem; border-top: 1px solid #eee; padding-top: 10px;">
                <button class="btn-audio-inline" onclick="toggleAudio(this, '${textPart2}')" style="float: right; margin-left:10px;" aria-label="Escuchar explicación"><span>🔊</span></button>
                <h3 style="color: #2980b9; font-size: 1.2rem; margin-bottom: 0.8rem; font-weight: bold;">🕵️ Detective de Datos Útiles</h3>
                <p style="margin-bottom: 1rem;">En un problema puede haber muchos números, pero solo son datos útiles los que nos ayudan a resolver la pregunta.</p>
                
                <div style="background-color: #e8f4fd; border-left: 5px solid #3498db; padding: 1rem; border-radius: 4px;">
                    <p><strong>Ejemplo:</strong> Si el problema dice que hay <em>"3 helados de fresa, 2 chocolatinas y 5 helados de chocolate"</em>, y te preguntan cuántos helados hay, los datos útiles serán:</p> 
                    <p style="margin-top: 5px;">🍦 <strong>“3 helados de fresa”</strong> y 🍦 <strong>"5 helados de chocolate"</strong>.</p>
                    <p style="margin-top: 10px; color: #e74c3c; font-weight: bold;">¡El número de chocolatinas no lo necesitamos para esa pregunta!</p>
                </div>
            </div>

            <!-- Infografía añadida -->
            <div style="margin-top: 1.5rem; text-align: center; border-top: 2px dashed #ccc; padding-top: 1rem;">
                <p style="font-size: 0.95rem; color: #666; font-weight: 600; margin-bottom: 8px;">👇 Haz clic en la imagen para verla en GRANDE 👇</p>
                <img src="infografia_pasos.jpg" 
                     alt="Infografía: Pasos para resolver un misterio" 
                     style="width: 100%; max-width: 400px; border-radius: 12px; cursor: zoom-in; box-shadow: 0 4px 10px rgba(0,0,0,0.1); transition: transform 0.2s;"
                     onclick="expandInfographic(this.src)"
                     class="help-infographic-thumb"
                />
            </div>
        </div>
        <div class="help-modal-footer">
            <button class="btn-close-modal" onclick="closeProblemHelpModal()">✅ ¡ENTENDIDO!</button>
        </div>
    `;
}

// Helper for image zoom (True Overlay)
window.expandInfographic = function (src) {
    // Create overlay container
    const overlay = document.createElement('div');
    overlay.id = 'infographicOverlay';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
    overlay.style.zIndex = '2147483650'; // Higher than modal (which is ...647)
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.style.cursor = 'zoom-out';
    overlay.style.opacity = '0'; // For fade in
    overlay.style.transition = 'opacity 0.3s ease';

    // Create Image
    const img = document.createElement('img');
    img.src = src;
    img.style.maxWidth = '95vw';
    img.style.maxHeight = '95vh';
    img.style.objectFit = 'contain';
    img.style.borderRadius = '8px';
    img.style.boxShadow = '0 0 20px rgba(255,255,255,0.2)';
    img.style.transform = 'scale(0.8)'; // Start slightly smaller
    img.style.transition = 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)';

    overlay.appendChild(img);
    document.body.appendChild(overlay);

    // Animate In
    requestAnimationFrame(() => {
        overlay.style.opacity = '1';
        img.style.transform = 'scale(1)';
    });

    // Close on click
    overlay.onclick = function () {
        overlay.style.opacity = '0';
        img.style.transform = 'scale(0.8)';
        setTimeout(() => {
            if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        }, 300);
    };
};

/**
 * Show the problem help modal
 */
async function showProblemHelpModal() {
    // 1. Check Wizard Step
    const isStep2Active = document.querySelector('#wizardStep2.active') !== null;
    const isStep1Active = document.querySelector('#wizardStep1.active') !== null;

    // 2. Ensure Modal Exists (Force rebuild if switching contexts could have messed it up)
    // If we are in Step 2, we want to construct step 2 content.
    // If we are in Step 1, we want standard content.
    // The simplest way to handle switching is to check if the current DOM matches expectations.

    let modal = document.getElementById('problemHelpModalV2');

    if (isStep2Active) {
        // Prepare for Step 2
        ensureModalExists(); // Create container if missing
        modal = document.getElementById('problemHelpModalV2');
        renderStep2HelpContent(modal);
        modal.classList.remove('hidden');
        return;
    }

    // Default: Step 1 or others (Visual Decomposition)
    // Check if we need to restore Step 1 structure (if Step 2 overwrote it)
    if (!modal || !modal.querySelector('#helpInicioText')) {
        ensureModalExists(true); // Force rebuild standard structure
        modal = document.getElementById('problemHelpModalV2');
    }

    // Load data and populate standard modal
    await loadProblemHelpData();
    let helpData = findCurrentProblemHelpData();

    if (!helpData) {
        const currentProblemIndex = typeof store !== 'undefined' ? store.state.currentProblem : 0;
        const currentProblem = typeof store.state !== 'undefined' && store.state.problems
            ? store.state.problems[currentProblemIndex]
            : null;
        if (currentProblem) {
            helpData = createFallbackHelpData(currentProblem);
        }
    }

    if (!helpData || !helpData.ayuda) {
        if (typeof readProblemAloud === 'function') readProblemAloud();
        return;
    }

    const ayuda = helpData.ayuda;

    const textInicio = ayuda.inicio.texto || '';
    let textCambio = ayuda.cambio.texto || '';
    
    // Eliminar conectores iniciales como "y", "pero", "luego", "después" en el texto de cambio
    textCambio = textCambio.replace(/^(?:\s*y\s+|\s*pero\s+|\s*luego\s+|\s*despu[eé]s\s*|,\s*)+/gi, '').trim();
    if (textCambio) {
        textCambio = textCambio.charAt(0).toUpperCase() + textCambio.slice(1);
    }
    
    const textPregunta = ayuda.pregunta.texto || '';

    // Configurar botones de audio
    const btnInicio = document.getElementById('audioBtnInicio');
    const btnCambio = document.getElementById('audioBtnCambio');
    const btnPregunta = document.getElementById('audioBtnPregunta');
    const btnAll = document.getElementById('btnPlayAllHelp');

    // Lógica Secuencial
    const playSequentially = (btn) => {
        if (!window.AudioManager) return;

        // Estado visual del botón "Escuchar Todo"
        if (btn) {
            btn.classList.add('playing');
            const span = btn.querySelector('span');
            if (span) span.textContent = '⏹️';
        }

        const onEnd = () => {
            if (btn) {
                btn.classList.remove('playing');
                const span = btn.querySelector('span');
                if (span) span.textContent = '🔊';
            }
        };

        // Función de ayuda para continuar solo si el modal sigue abierto
        const shouldContinue = () => {
            const modal = document.getElementById('problemHelpModalV2');
            return modal && !modal.classList.contains('hidden');
        };

        // CADENA DE REPRODUCCIÓN SECUENCIAL (Optimizada con speakParts)
        const helpParts = [
            "AL PRINCIPIO...",
            textInicio,
            "DESPUÉS...",
            textCambio,
            "LA PREGUNTA ES...",
            textPregunta
        ];

        if (window.AudioManager && window.AudioManager.speakParts) {
            window.AudioManager.speakParts(helpParts, window.currentLanguage, onEnd);
        } else {
            // Fallback manual si AudioManager no soporta partes
            window.speakWithCallback(helpParts[0], window.currentLanguage, () => {
                if (!shouldContinue()) return;
                window.speakWithCallback(textInicio, window.currentLanguage, () => {
                    if (!shouldContinue()) return;
                    window.speakWithCallback("DESPUÉS...", window.currentLanguage, () => {
                        if (!shouldContinue()) return;
                        window.speakWithCallback(textCambio, window.currentLanguage, () => {
                            if (!shouldContinue()) return;
                            window.speakWithCallback("LA PREGUNTA ES...", window.currentLanguage, () => {
                                if (!shouldContinue()) return;
                                window.speakWithCallback(textPregunta, window.currentLanguage, onEnd);
                            });
                        });
                    });
                });
            });
        }
    };

    if (btnInicio) btnInicio.onclick = () => window.toggleAudio(btnInicio, textInicio);
    if (btnCambio) btnCambio.onclick = () => window.toggleAudio(btnCambio, textCambio);
    if (btnPregunta) btnPregunta.onclick = () => window.toggleAudio(btnPregunta, textPregunta);

    // El botón "Escuchar Todo" ahora dispara la secuencia
    if (btnAll) {
        btnAll.onclick = () => {
            if (btnAll.classList.contains('playing')) {
                window.stopAudio();
                btnAll.classList.remove('playing');
                const span = btnAll.querySelector('span');
                if (span) span.textContent = '🔊';
            } else {
                playSequentially(btnAll);
            }
        };
    }

    // Populate Image from current problem
    const helpImageContainer = document.getElementById('helpImageContainer');
    const helpImage = document.getElementById('helpImage');
    if (helpImageContainer && helpImage) {
        // Get current problem to access its images
        const currentProblemIndex = typeof store !== 'undefined' ? store.state.currentProblem : 0;
        const currentProblem = typeof store.state !== 'undefined' && store.state.problems
            ? store.state.problems[currentProblemIndex]
            : null;

        if (currentProblem && currentProblem.images && currentProblem.images.length > 0) {
            helpImage.src = currentProblem.images[0];
            helpImage.onload = () => helpImageContainer.style.display = 'block';
            helpImage.onerror = () => helpImageContainer.style.display = 'none';
        } else {
            helpImageContainer.style.display = 'none';
        }
    }

    // Populate Section 1
    const inicioText = document.getElementById('helpInicioText');
    const inicioEmojis = document.getElementById('helpInicioEmojis');
    if (inicioText) inicioText.textContent = textInicio || 'Situación inicial';
    if (inicioEmojis) {
        const bestEmoji = getBestEmoji(textInicio, ayuda.inicio.emoji);
        if (isValidEmojiCode(bestEmoji) && ayuda.inicio.cantidad > 0) {
            inicioEmojis.innerHTML = generateTwemojiImages(bestEmoji, ayuda.inicio.cantidad);
            inicioEmojis.style.display = 'flex';
        } else {
            inicioEmojis.style.display = 'none';
        }
    }

    // Populate Section 2
    const cambioText = document.getElementById('helpCambioText');
    const cambioOperator = document.getElementById('helpCambioOperator');
    const cambioImages = document.getElementById('helpCambioImages');
    if (cambioText) cambioText.textContent = textCambio || 'Cambio';
    if (cambioOperator) {
        const isSubtraction = ayuda.cambio.operacion === '-' || textCambio.toLowerCase().includes('vendieron') || textCambio.toLowerCase().includes('comen');
        cambioOperator.textContent = isSubtraction ? '−' : '+';
        cambioOperator.className = 'cambio-operator ' + (isSubtraction ? 'minus' : 'plus');
    }
    if (cambioImages) {
        const bestEmoji = getBestEmoji(textCambio, ayuda.cambio.emoji);
        if (isValidEmojiCode(bestEmoji) && ayuda.cambio.cantidad > 0) {
            cambioImages.innerHTML = generateTwemojiImages(bestEmoji, ayuda.cambio.cantidad);
            document.getElementById('helpCambioEmojis').style.display = 'flex';
        } else {
            document.getElementById('helpCambioEmojis').style.display = 'none';
        }
    }

    // Populate Section 3
    const preguntaText = document.getElementById('helpPreguntaText');
    if (preguntaText) preguntaText.textContent = textPregunta || 'Pregunta';

    modal.classList.remove('hidden');

    // Trigger help audio automatically on open
    if (btnAll) {
        // Small delay to let the modal show up first
        setTimeout(() => {
            playSequentially(btnAll);
        }, 400);
    }
}

/**
 * Close the problem help modal
 */
function closeProblemHelpModal() {
    const modal = document.getElementById('problemHelpModalV2');
    if (modal) {
        modal.classList.add('hidden');
    }

    // Detener cualquier audio en curso (nativo o ElevenLabs)
    if (window.stopAudio) {
        window.stopAudio();
    } else {
        if (window.ElevenLabsTTS) window.ElevenLabsTTS.stop();
        if (window.speechSynthesis) window.speechSynthesis.cancel();
    }
}

// Export functions
window.showProblemHelpModal = showProblemHelpModal;
window.closeProblemHelpModal = closeProblemHelpModal;

/**
 * Shared utility for other modules (like WorkBoard) to get the same help data
 */
window.getUnifiedProblemHelp = async function () {
    await loadProblemHelpData();
    let helpData = findCurrentProblemHelpData();

    if (!helpData) {
        const currentProblemIndex = typeof store !== 'undefined' ? store.state.currentProblem : 0;
        const currentProblem = typeof store.state !== 'undefined' && store.state.problems
            ? store.state.problems[currentProblemIndex]
            : null;
        if (currentProblem) {
            helpData = createFallbackHelpData(currentProblem);
        }
    }
    return helpData;
};

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    loadProblemHelpData();
});

Logger.log('✅ Problem Help Modal module loaded (Dual Mode)');
